module.exports = __webpack_public_path__ + "img/deadluck_unbuffered.21378e95.png";